export enum EventViewState {
  CREATE = 1,
  EDIT,
  PREVIEW,
}
